<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div @click="setTabTittleColor('user')">
          <h2 :class="getTabTittleColor(dynamicStyle.user)">User</h2>
          <template v-if="dynamicStyle.user">
            <div class="line" />
          </template>
        </div>
        <div @click="setTabTittleColor('enrolled')">
          <h2 :class="getTabTittleColor(dynamicStyle.enrolled)">Enrolled</h2>
          <template v-if="dynamicStyle.enrolled">
            <div class="line" />
          </template>
        </div>
        <div @click="setTabTittleColor('completed')">
          <h2 :class="getTabTittleColor(dynamicStyle.completed)">Complete</h2>
          <template v-if="dynamicStyle.completed">
            <div class="line" />
          </template>
        </div>
      </div>
      <div class="row-card-title right">
        <div class="custom-button-view-all">
          <h2 class="card-titile-view-all">VIEW ALL</h2>
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow alignHorizontal="between">
            <div>
              <CButtonGroup>
                <CButton
                  :class="getGroupButtonColor(graphViewType.weekly)"
                  @click="onChangeTab('week')"
                >Weekly</CButton>
                <CButton
                  :class="getGroupButtonColor(graphViewType.monthly)"
                  @click="onChangeTab('month')"
                >Monthly</CButton>
                <CButton
                  :class="getGroupButtonColor(graphViewType.yearly)"
                  @click="onChangeTab('year')"
                >Yearly</CButton>
              </CButtonGroup>
            </div>
          </CRow>
          <CRow alignHorizontal="center">
            <CCol>
              <CChartLine :datasets="getMfuAndMdlData()" labels="months" />
              <CRow>
                <template v-for="detail in details">
                  <CCol
                    :key="detail.label"
                    style="display: flex; flex-direction: column; align-content: center; justify-content: center"
                  >
                    <div style="font-size:18px; text-align: center">{{capilalize(detail.month)}}</div>
                    <strong
                      style="color: #002B9C; font-size: 12px; text-align: center"
                    >{{detail.mfu}}</strong>
                    <strong
                      style="color: #FB9879; font-size: 12px; text-align: center"
                    >{{detail.mdl}}</strong>
                  </CCol>
                </template>
              </CRow>
            </CCol>
          </CRow>
        </CContainer>
      </div>
    </CRow>
  </CContainer>
</template>

<script>
import { mapGetters } from "vuex";
import { CChartLine } from "@coreui/vue-chartjs";
import graphViewTypeComponent from "../dashboard/graphViewTypeComponent";
import userOverviewTitleTab from "../dashboard/userOverviewTitleTab";
import "../../../assets/scss/_adminStyle.scss"

export default {
  name: "UserOverview",
  components: {
    CChartLine,
    graphViewTypeComponent,
    userOverviewTitleTab
  },
  data() {
    return {
      graphViewType: { weekly: false, monthly: true, yearly: false },
      rollHoler: "user",
      userOverviewMonth: [],
      userOverviewWeek: [],
      userOverviewYear: [],
      userEnrolledMonth: [],
      userEnrolledWeek: [],
      userEnrolledYear: [],
      userCompleteMonth: [],
      userCompleteWeek: [],
      userCompleteYear: [],
      details: [],
      munOfMfuUser: [],
      munOfMdlUser: [],
      dynamicStyle: { user: true, enrolled: false, completed: false }
    };
  },
  created() {},
  mounted() {
    this.fetchUserOverviewData();
  },
  computed: {
    ...mapGetters([
      "userOverviewGetter",
      "userEnrolledGetter",
      "userCompleteGetter"
    ])
  },
  watch: {
    userOverviewGetter: function(val) {
      this.userOverviewWeek = val.week[0];
      this.userOverviewMonth = val.month[0];
      this.userOverviewYear = val.year[0];

      this.setDetails(this.userOverviewMonth.mfu, this.userOverviewMonth.mdl);
      this.setMunOfMfuUser(this.userOverviewMonth.mfu);
      this.setMunOfMdlUser(this.userOverviewMonth.mdl);
    },
    userEnrolledGetter: function(val) {
      this.userEnrolledWeek = val.week[0];
      this.userEnrolledMonth = val.month[0];
      this.userEnrolledYear = val.year[0];
    },
    userCompleteGetter: function(val) {
      this.userCompleteWeek = val.week[0];
      this.userCompleteMonth = val.month[0];
      this.userCompleteYear = val.year[0];
    }
  },
  methods: {
    capilalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    clearUserData() {
      this.details = [];
      this.munOfMfuUser = [];
      this.munOfMdlUser = [];
    },
    mappingGraph(mfu, mdl) {
      this.clearUserData();
      this.setDetails(mfu, mdl);
      this.setMunOfMfuUser(mfu);
      this.setMunOfMdlUser(mdl);
    },
    onChangeTab(tabName) {
      if (tabName == "week") {
        if (this.rollHoler == "user") {
          this.graphViewType = { weekly: true, monthly: false, yearly: false };
          this.mappingGraph(
            this.userOverviewWeek.mfu,
            this.userOverviewWeek.mdl
          );
        } else if (this.rollHoler == "enrolled") {
          this.graphViewType = { weekly: true, monthly: false, yearly: false };
          this.mappingGraph(
            this.userEnrolledWeek.mfu,
            this.userEnrolledWeek.mdl
          );
        } else if (this.rollHoler == "completed") {
          this.graphViewType = { weekly: true, monthly: false, yearly: false };
          this.mappingGraph(
            this.userCompleteWeek.mfu,
            this.userCompleteWeek.mdl
          );
        }
      } else if (tabName == "month") {
        if (this.rollHoler == "user") {
          this.graphViewType = { weekly: false, monthly: true, yearly: false };
          this.mappingGraph(
            this.userOverviewMonth.mfu,
            this.userOverviewMonth.mdl
          );
        } else if (this.rollHoler == "enrolled") {
          this.graphViewType = { weekly: false, monthly: true, yearly: false };
          this.mappingGraph(
            this.userEnrolledMonth.mfu,
            this.userEnrolledMonth.mdl
          );
        } else if (this.rollHoler == "completed") {
          this.graphViewType = { weekly: false, monthly: true, yearly: false };
          this.mappingGraph(
            this.userCompleteMonth.mfu,
            this.userCompleteMonth.mdl
          );
        }
      } else if (tabName == "year") {
        if (this.rollHoler == "user") {
          this.graphViewType = { weekly: false, monthly: false, yearly: true };
          this.mappingGraph(
            this.userOverviewYear.mfu,
            this.userOverviewYear.mdl
          );
        } else if (this.rollHoler == "enrolled") {
          this.graphViewType = { weekly: false, monthly: false, yearly: true };
          this.mappingGraph(
            this.userEnrolledYear.mfu,
            this.userEnrolledYear.mdl
          );
        } else if (this.rollHoler == "completed") {
          this.graphViewType = { weekly: false, monthly: false, yearly: true };
          this.mappingGraph(
            this.userCompleteYear.mfu,
            this.userCompleteYear.mdl
          );
        }
      }
    },

    fetchUserOverviewData() {
      this.$store.dispatch("fetchUserOverviewData");
      this.$store.dispatch("fetchUserEnrolledData");
      this.$store.dispatch("fetchUserCompleteData");
    },
    setMunOfMfuUser(data) {
      for (let x of data) this.munOfMfuUser.push(x.value);
    },
    setMunOfMdlUser(data) {
      for (let x of data) this.munOfMdlUser.push(x.value);
    },
    getMfuAndMdlData() {
      return [
        {
          data: this.munOfMfuUser,
          backgroundColor: "rgba(0, 29, 197, 0.5)",
          label: "MFU"
        },
        {
          data: this.munOfMdlUser,
          backgroundColor: "rgba(255, 180, 156, 0.5)",
          label: "MDL"
        }
      ];
    },
    setDetails(mfu, mdl) {
      if (mfu.length == mdl.length)
        for (let i = 0; i < mfu.length; i++)
          if (mfu[i].title == mdl[i].title)
            this.details.push({
              month: mfu[i].title,
              mfu: mfu[i].value,
              mdl: mdl[i].value
            });
    },
    getGroupButtonColor(status) {
      switch (status) {
        case true:
          return "button-group-active";
        case false:
          return "button-group";
      }
    },
    getTabTittleColor(status) {
      switch (status) {
        case true:
          return "card-title-active";
        case false:
          return "card-title";
      }
    },
    setTabTittleColor(state) {
      switch (state) {
        case "user":
          this.dynamicStyle = { user: true, enrolled: false, completed: false };
          this.rollHoler = "user";
          this.clearUserData();
          this.setDetails(
            this.userOverviewMonth.mfu,
            this.userOverviewMonth.mdl
          );
          this.setMunOfMfuUser(this.userOverviewMonth.mfu);
          this.setMunOfMdlUser(this.userOverviewMonth.mdl);
          break;
        case "enrolled":
          this.dynamicStyle = { user: false, enrolled: true, completed: false };
          this.graphViewType = { weekly: false, monthly: true, yearly: false };
          this.rollHoler = "enrolled";
          this.clearUserData();
          this.setDetails(
            this.userEnrolledMonth.mfu,
            this.userEnrolledMonth.mdl
          );
          this.setMunOfMfuUser(this.userEnrolledMonth.mfu);
          this.setMunOfMdlUser(this.userEnrolledMonth.mdl);
          break;
        case "completed":
          this.dynamicStyle = { user: false, enrolled: false, completed: true };
          this.graphViewType = { weekly: false, monthly: true, yearly: false };
          this.rollHoler = "completed";
          this.clearUserData();
          this.setDetails(
            this.userCompleteMonth.mfu,
            this.userCompleteMonth.mdl
          );
          this.setMunOfMfuUser(this.userCompleteMonth.mfu);
          this.setMunOfMdlUser(this.userCompleteMonth.mdl);
          break;
      }
    }
  }
};
</script>
